"use client";

import { useEffect, useState } from "react";

/**
 * 画面上部に固定する読了プログレスバー。
 * <article> 要素（記事本文領域）のスクロール到達率に応じて伸長する。
 * navy → accent のグラデーション。装飾要素のため aria-hidden。
 */
export default function ReadingProgress() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const article = document.querySelector("article");

    const update = () => {
      const target = article ?? document.documentElement;
      const rect = target.getBoundingClientRect();
      const viewport = window.innerHeight;
      // 記事の先頭から末尾までを 0→1 に正規化
      const total = rect.height - viewport;
      if (total <= 0) {
        setProgress(rect.top <= 0 ? 100 : 0);
        return;
      }
      const scrolled = Math.min(Math.max(-rect.top, 0), total);
      setProgress((scrolled / total) * 100);
    };

    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    return () => {
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, []);

  return (
    <div
      className="fixed inset-x-0 top-0 z-50 h-[3px] bg-transparent"
      aria-hidden
    >
      <div
        className="h-full bg-gradient-to-r from-navy-700 to-accent transition-[width] duration-150 ease-out"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
}
